import moment from 'moment';
export default function formatDate(date, format = 'yyyy/MM/DD HH:mm') {
    return moment(date).format(format);
}
